import Backbone from 'backbone'
import template from './notification-preferences.hbs'
import formHelper from 'scoreboard/components/form-helper'
import momentHelper from 'scoreboard/components/moment-helper'
import $ from 'jquery'
import permissions from 'scoreboard/components/permissions'
import selects from 'scoreboard/components/selects'

/**
 * the selects to change alert notification preferences
 */
const NotificationPreferences = Backbone.View.extend({

	events: {
		'change .notification-frequency, .notification-day': 'changePreferences'
	},

	initialize: function(opts={}) {
		this.opts = opts
		this.data = this.opts.data
	},

	render: function() {
		this.$el.empty().append(template)
		formHelper.writeToDom(this.data.preferences, this.el)
		this.toggleDays()
		this.secure()
		selects(this.$('select'))

		return this
	},

	toggleDays: function() {
		// make sure the days dropdown is shown if appropriate
		var frequency = this.$('[name=frequency]').val()
		this.$('.notification-day').toggleClass('is-not-displayed', frequency !== 'weekly')
	},

	changePreferences: function() {
		this.toggleDays()
		var newPreferences = formHelper.readFromDom(this.el)
		newPreferences.timezoneOffset = momentHelper.readTimeZoneOffset()
		if (newPreferences.frequency !== 'weekly') {
			delete newPreferences.day
		}
		this.data.preferences = newPreferences
		$.post('api/alerts/subscriptions/preferences', JSON.stringify(newPreferences))
	},

	secure: function() {
		if (!permissions.bookmarks()) {
			// disable the email frequency selects
			this.$('.notification-frequency, .notification-day').prop('disabled', true)
		}
	},

	autoRemove: true
})

export default NotificationPreferences
NotificationPreferences.__filename__ = 'admin/alerts/notification-preferences.js'
